__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "qdi-admin-customers-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@qldtmr/tmr-swe-react-library", "1.0.2", () => (__webpack_require__.e("node_modules_qldtmr_tmr-swe-react-library_dist_esm_index_js-_b7251").then(() => (() => (__webpack_require__(/*! ./node_modules/@qldtmr/tmr-swe-react-library/dist/esm/index.js */ "./node_modules/@qldtmr/tmr-swe-react-library/dist/esm/index.js"))))));
			register("aws-amplify", "5.3.26", () => (__webpack_require__.e("node_modules_aws-amplify_lib-esm_index_js").then(() => (() => (__webpack_require__(/*! ./node_modules/aws-amplify/lib-esm/index.js */ "./node_modules/aws-amplify/lib-esm/index.js"))))));
			register("moment", "2.29.4", () => (__webpack_require__.e("node_modules_moment_moment_js").then(() => (() => (__webpack_require__(/*! ./node_modules/moment/moment.js */ "./node_modules/moment/moment.js"))))));
			register("react-router-dom", "6.11.2", () => (__webpack_require__.e("node_modules_react-router-dom_dist_index_js-_48e81").then(() => (() => (__webpack_require__(/*! ./node_modules/react-router-dom/dist/index.js */ "./node_modules/react-router-dom/dist/index.js"))))));
			register("react", "18.2.0", () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! ./node_modules/react/index.js */ "./node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};